import React, { useEffect, useMemo } from 'react';
import { useApolloClient } from '@apollo/react-hooks';
import { hasCompletePricingSnapshot } from '@msales/shared/utils/orderPricingSnapshot';
import { useAuthContext, useCartContext, useClientConfig, useCustomerContext } from '../../context';
import useProductEntryPricing from '../../hooks/useProductEntryPricing';
import { getProductPriceLoader } from '../../utils/productPriceInquiry';

const PendingCartPrice = React.memo(({ productId, tariffGroup }) => {
  const product = useMemo(() => ({ id: productId, tarifnaGrupa: tariffGroup }), [productId, tariffGroup]);
  useProductEntryPricing(product, { selected: false, inCart: true });
  return null;
});

const CartPriceRequests = () => {
  const { cart } = useCartContext();
  return cart.filter((item) => !hasCompletePricingSnapshot(item)).map((item) => (
    <PendingCartPrice
      key={item.id}
      productId={item.id}
      tariffGroup={item.tarifnaGrupa ?? item.tarifnagrupa}
    />
  ));
};

const PriceInquirySession = React.memo(() => {
  const client = useApolloClient();
  const loader = getProductPriceLoader(client);
  useEffect(() => loader.retain(), [loader]);
  return <CartPriceRequests />;
});

const CartPriceInquiry = () => {
  const { customer } = useCustomerContext();
  const { authUser } = useAuthContext();
  const { getValue } = useClientConfig();
  if (!customer?.id || !authUser?.id || !getValue('productPricing.usePriceInquiry', false)) return null;
  return <PriceInquirySession key={JSON.stringify([authUser.id, customer.id])} />;
};

export default CartPriceInquiry;
